import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { Plan } from './Plan'

interface SubscriptionData {
  marketing: boolean
  how_did_you_header_of: number
  how_did_you_heard_of_pr_ambassador?: string
  referral: {
    recommendation: boolean
    contact?: {
      firstName: string
      lastName: string
      phone: string
      email?: string
    }
  }
}

interface CreateSubscriptionData {
  plan: number
  persons: {
    firstName: string
    lastName: string
    email: string
    phone: string
  }[]
  paymentRequired: boolean
}

type CancelSubscriptionStatus = 'cancelled' | 'to_cancel'

type SubscriptionStatus =
  | 'awaiting_payment_data'
  | 'to_review'
  | 'payment_failed'
  | 'active'
  | 'awaiting_capture'
  | 'awaiting_transfer'
  | 'awaiting_transfer_renewal'
  | CancelSubscriptionStatus

interface Subscription extends SBModel {
  uuid: string
  status: SubscriptionStatus
  plan?: Plan
  frontendUrl: string
  coupon?: number
  membershipProfiles?: number[]
  data: SubscriptionData
  renewalDate: string
  createdAt: string
  updatedAt: string
  tags?: number[]
}

const subscriptionRequestStatuses: SubscriptionStatus[] = [
  'to_review',
  'awaiting_capture',
  'payment_failed',
  'awaiting_payment_data',
  'awaiting_transfer',
  'awaiting_transfer_renewal',
]

const subscriptionAwaitingTransferStatuses: SubscriptionStatus[] = [
  'awaiting_transfer',
  'awaiting_transfer_renewal',
]
const subscriptionMembersStatuses: SubscriptionStatus[] = [
  'active',
  'cancelled',
]

export {
  subscriptionAwaitingTransferStatuses,
  subscriptionMembersStatuses,
  subscriptionRequestStatuses,
}
export type {
  CancelSubscriptionStatus,
  CreateSubscriptionData,
  Subscription,
  SubscriptionData,
  SubscriptionStatus,
}
